import set from 'lodash/set';
import state from 'store/state/auth';
import types from 'store/types/auth';

const initialState = state;

export default (state = initialState, action) => {
  const { key, data } = action;

  switch (action.type) {
    case types.AUTH_SET:
      set(state, key, data);
      return { ...state };
    default:
      return state;
  }
};
